import { DEFAULT_JOB_OWNER, type IntegrationJob } from "../../shared/types";
import { mockJobs } from "../mocks/jobs";
import { getWithFallback, postRequired } from "./apiClient";

export function withDefaultJobOwner(job: IntegrationJob): IntegrationJob {
  return {
    ...job,
    owner: DEFAULT_JOB_OWNER
  };
}

export async function getJobs(): Promise<IntegrationJob[]> {
  const jobs = await getWithFallback("/jobs", () => mockJobs);
  return jobs.map(withDefaultJobOwner);
}

export async function getJob(jobId: string): Promise<IntegrationJob | undefined> {
  const job = await getWithFallback(`/jobs/${jobId}`, () => mockJobs.find((item) => item.id === jobId));
  return job ? withDefaultJobOwner(job) : undefined;
}

export function saveJob(job: IntegrationJob): Promise<IntegrationJob> {
  return postRequired<IntegrationJob, IntegrationJob>("/jobs", withDefaultJobOwner(job))
    .then(withDefaultJobOwner);
}
